import { validateType, validateObjectKeys } from "@litres/utils";

import type { IVarioqubResponse } from "./varioqub.types";

/* ВНИМАНИЕ!!!!!!!
 * Копия данного валидатора лежит в папке с сервером /apps/next-app/server/utils/varioqub-utils.js
 * если будете что-то править надо изменить там тоже
 *
 * Формат ответа
 * {
    i: "7ASX7O3PO+SD4f30Y1GqkUEVIgyJ",
    experiments: "JjfiHndoV8s",
    flags: [
      {
        n: "flag_name",
        v: "value",
        t: "flag",
      },
    ],
    testids: [1234, 4567],
  };
 */
export const varioqubResponseValidator = (response: IVarioqubResponse) => {
  validateObjectKeys(response, ["i", "experiments", "flags"]);
  validateType(response.i, "string");
  validateType(response.experiments, "string");
  validateType(response.flags, "array");
  if (response.testids) {
    validateType(response.testids, "array");
  }

  if (response.flags.length) {
    const flag = response.flags[0];
    validateType(flag, "object");
    validateObjectKeys(flag, ["n", "v", "t"]);
    validateType(flag.n, "string");
    validateType(flag.v, "string");
    validateType(flag.t, "string");
  }

  if (response.testids?.length) {
    validateType(response.testids[0], "number");
  }

  return response;
};
